/* eslint-disable max-len */

export const notEqualTestDataValidator = (value, notEqualToInputValue) => {
  if (value === '-' || value === undefined) return true;
  return value !== notEqualToInputValue;
};
